import React, { useCallback, useEffect, useRef, useState } from "react";
import SidebarChatLink from "./SidebarChatLink";
import { useUsersContext } from "../../../context/usersContext";

// The search + collapse controls now live at the top of the sidebar (above
// AppNav) in AppShell, matching the Lovable AppSidebar. AppShell owns the
// collapsed state and passes it down so the history list can hide when the
// rail is collapsed.
const ChatHistorySidebar = ({ collapsed = false }) => {
  const { fetchChats, conversations } = useUsersContext();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const loaderRef = useRef(null);


  const getChats = async () => {
    setLoading(true);
    await fetchChats(page);
    setLoading(false);
  };

  useEffect(() => {
    getChats();
  }, [page]);

  const handleObserver = useCallback(
    (entries) => {
      const target = entries[0];
      if (target.isIntersecting && conversations.hasMore && !loading) {
        setPage((prev) => prev + 1);
      }
    },
    [conversations],
  );

  useEffect(() => {
    const option = {
      root: null,
      rootMargin: "200px",
      threshold: 0,
    };
    if (conversations.hasMore) {
      const observer = new IntersectionObserver(handleObserver, option);

      if (loaderRef.current) {
        observer.observe(loaderRef.current);
      }
      return () => observer.disconnect();
    }
  }, [handleObserver]);

  if (collapsed) return null;

  return (
    <div className="w-full h-full" style={{ fontFamily: "Inter" }}>
      <div className="h-full overflow-y-auto v3chat__content">
        <p className="text-xs font-medium uppercase tracking-wide pl-3.5 mt-5 mb-2 text-muted-foreground">
          Task History
        </p>
        <div>
          {conversations?.data?.favChats?.length > 0 &&
            conversations?.data?.favChats?.map((chat) => (
              <SidebarChatLink item={chat} key={chat.conversation_id} />
            ))}
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wide pl-3.5 mt-5 mb-2 text-muted-foreground">
            Today
          </p>
          {conversations?.data?.today?.length > 0 &&
            conversations?.data?.today?.map((chat) => (
              <SidebarChatLink
                fav={false}
                item={chat}
                key={chat.conversation_id}
              />
            ))}
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wide pl-3.5 mt-5 mb-2 text-muted-foreground">
            Yesterday
          </p>
          {conversations?.data?.yesterday?.length > 0 &&
            conversations?.data?.yesterday?.map((chat) => (
              <SidebarChatLink
                fav={false}
                item={chat}
                key={chat.conversation_id}
              />
            ))}
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wide pl-3.5 mt-5 mb-2 text-muted-foreground">
            Previous 7 Days
          </p>
          {conversations?.data?.last7Day?.length > 0 &&
            conversations?.data?.last7Day?.map((chat) => (
              <SidebarChatLink
                fav={false}
                key={chat.conversation_id}
                item={chat}
              />
            ))}
        </div>
        <div ref={loaderRef} className="h-[40px] text-center w-full">
          {loading && "Loading..."}
        </div>
      </div>
    </div>
  );
};

export default ChatHistorySidebar;
